var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7413 1.9796H13.326L7.41695 7.89147C7.2256 8.08282 7.2256 8.39413 7.41695 8.58548C7.5112 8.67972 7.63686 8.72827 7.76252 8.72827C7.88819 8.72827 8.01385 8.67972 8.1081 8.58548L14.02 2.6736V5.25826C14.02 5.52958 14.2399 5.74949 14.5083 5.74949C14.7797 5.74949 14.9996 5.52958 14.9996 5.25826V1.49123C14.9996 1.21991 14.7797 1 14.5083 1H10.7413C10.47 1 10.2501 1.21991 10.2501 1.49123C10.2529 1.75969 10.47 1.9796 10.7413 1.9796Z",
    fill: "#535151",
    stroke: "#535151",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9388 15H12.0583C13.6805 15 14.9971 13.6805 14.9971 12.0612V8.23705C14.9971 7.96573 14.7772 7.74867 14.5059 7.74867C14.2346 7.74867 14.0175 7.96858 14.0175 8.23705V12.0583C14.0175 13.1379 13.1379 14.0175 12.0583 14.0175H3.9388C2.85924 14.0175 1.9796 13.1379 1.9796 12.0583V5.60955V3.94166C1.9796 2.8621 2.85924 1.98246 3.9388 1.98246H7.72868C8 1.98246 8.21705 1.76255 8.21705 1.49123C8.21705 1.21991 7.99714 1 7.72868 1H3.9388C2.31661 1 1 2.31946 1 3.9388V5.60669V12.0583C1 13.6805 2.31946 15 3.9388 15Z",
    fill: "#535151",
    stroke: "#535151",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBold);
export default __webpack_public_path__ + "static/media/link-bold.3e8f88c8e99332433deaf8e3246d14f2.svg";
export { ForwardRef as ReactComponent };